"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentType = exports.FeatureIDs = exports.FeatureContext = void 0;
var FeatureContext;
(function (FeatureContext) {
    FeatureContext["ORGANIZATION"] = "ORGANIZATION";
    FeatureContext["VENUE"] = "VENUE";
})(FeatureContext = exports.FeatureContext || (exports.FeatureContext = {}));
var FeatureIDs;
(function (FeatureIDs) {
    FeatureIDs["ALLERGENS"] = "allergens";
    FeatureIDs["BOOKINGS"] = "bookings";
    FeatureIDs["CDS"] = "customer_display";
    FeatureIDs["COURSES"] = "courses";
    FeatureIDs["CUSTOMER_ACCOUNT"] = "customer_account";
    FeatureIDs["KDS"] = "kitchen_display";
    FeatureIDs["LOYALTY"] = "loyalty";
    FeatureIDs["MULTI_VENUE"] = "multi_venue";
    FeatureIDs["PRICE_LIST"] = "price_list";
    FeatureIDs["REFUND_REASON"] = "refund_reason";
    FeatureIDs["TABLE_MANAGEMENT"] = "table_management";
})(FeatureIDs = exports.FeatureIDs || (exports.FeatureIDs = {}));
var ComponentType;
(function (ComponentType) {
    ComponentType["TAB"] = "tab";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
//# sourceMappingURL=features.js.map